// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__3GR5O","menu":"Contacts_menu__gFD9L","icon":"Contacts_icon__1Q3oL"};